import equalArgs from './equal-args';

const memoize = (fn) => {
    let _cachedArgs;
    let _cachedResult;

    return (...args) => {
        if (!_cachedArgs || !equalArgs(args, _cachedArgs)) {
            _cachedResult = fn(...args);
            _cachedArgs = args;
        }
        return _cachedResult;
    };
};

export default memoize;
